var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-pagination"},[_c('div',{staticClass:"b-pagination-list"},[_c('ul',[_c('li',[_c('em')])])])])}]

export { render, staticRenderFns }